import createIcon from '../../createIcon';

/**
 * @component @name Onek
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0g1QzMuOSAzIDMgMy45IDMgNVYxOUMzIDIwLjEgMy45IDIxIDUgMjFIMTlDMjAuMSAyMSAyMSAyMC4xIDIxIDE5VjVDMjEgMy45IDIwLjEgMyAxOSAzWk0xMC41IDE1SDlWMTAuNUg3LjVWOUgxMC41VjE1Wk0xNy41IDE1SDE1Ljc1TDE0IDEyLjc1VjE1SDEyLjVWOUgxNFYxMS4yNUwxNS43NSA5SDE3LjVMMTUuMjUgMTJMMTcuNSAxNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Onek = createIcon('Onek', [
  [
    'path',
    {
      d: 'M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM10.5 15H9V10.5H7.5V9H10.5V15ZM17.5 15H15.75L14 12.75V15H12.5V9H14V11.25L15.75 9H17.5L15.25 12L17.5 15Z',
      key: 'wywzen',
    },
  ],
]);

export default Onek;
